import ORDER_API from '@/api/purchaseSalesCenter/wumaoPurchaseSales.js';
import { mapNumToString, formatDate } from '@/utils';

export default {
  data() {
    return {
      // 新增的
      isEdit: false,
      fetchFormData: {},
      orderDetailList: [],
      attachmentList: [],
      orderContractRelationshipList: [],
      orderAppointmentList: [],
      isDisabledForm: false,
      contractStatus: null,
      detailPageData: {},
    };
  },
  mounted() {
    if (this.$route.query.status == 'create') {
      this.isEdit = true;
    } else {
      this.isEdit = false;
      this.getOrderDetail();
    }
  },
  methods: {
    // 获取详情数据
    async getOrderDetail() {
      this.loading.startLoading();
      const isCopy = this.$route.query.isCopy == 'true';
      const postData = {
        contractNo: this.$route.query.contractNo,
        dataGroup: 'wm',
      };
      const copyData = {
        copyFlag: this.$route.query.copyFlag || 0,
        relationContractDetailCategory: this.$route.query.type,
      };
      const { data } = await this.$axios.post(
        ORDER_API.GET_ORDER_DETAIL_API,
        isCopy ? { ...postData, ...copyData } : postData
      );
      this.loading.endLoading();
      console.log(data, '111');
      if (data.code == 0) {
        let rawData = data.data;
        if (!isCopy && this.$route.query.type == 'CG01') {
          rawData.companyName = rawData.contractBusinessCompanyName;
          rawData.companyCode = rawData.contractBusinessCompanyNo;
          rawData.departmentCode = rawData.contractBusinessDepartment;
          rawData.departmentName = rawData.contractBusinessDepartmentName;
        }
        if (this.$route.query.isCopy == 'true' && this.$route.query.isEdit == 'false') {
          rawData.contractCreateDate = formatDate(new Date());
        }
        this.fetchFormData = mapNumToString(rawData);
        this.detailPageData = data.data;
        this.orderDetailList = data.data?.orderDetailList || [];
        this.attachmentList = data.data?.attachmentList || [];
        this.orderContractRelationshipList = data.data?.orderContractRelationshipList || [];
        this.orderAppointmentList = data.data?.orderAppointmentList || [];
        this.contractStatus = data.data.contractStatus;
        this.isRestrict = data?.data?.isRestrict;
        if (this.$route.query.isCopy == 'true' && this.$route.query.isEdit == 'false') {
          console.log('复制合同');
        } else {
          // 禁用
          const disableList = this._formItemIsDisabledByContractStatus(); // 禁用表单
          // 编辑模式根据判断来禁止,极端状态空数组表示全部禁止
          if (disableList) {
            if (disableList.length == 0) {
              this.isDisabledForm = true; // 全部禁止
            } else {
              this.disabledFieldList = disableList; // 部分禁止
            }
          }
        }
      } else {
        this.$message.error('获取详情数据失败');
      }
    },
    // 根据状态来判断表单是否禁用
    _formItemIsDisabledByContractStatus() {
      // TODO 这块需求未全面确定，先一个状态一个状态判断
      const currentContractStatus = this.contractStatus;

      if (this.$route.query.isCopy == 'true' && this.$route.query.isEdit == 'false') {
        return [];
      }
      // 根据状态判断表单禁用
      if (currentContractStatus == 'ZT02') {
        // 审批中
        this.isShowDownBtn = true;
        this.isDisableOverdueInterest = true;
        return [];
      } else if (currentContractStatus == 'ZT03') {
        this.isShowDownBtn = true;
        return [];
      } else if (currentContractStatus == 'ZT07') {
        this.isShowDownBtn = true;
        return []; // 全部禁用
      } else if (currentContractStatus == 'ZT021') {
        // 【是否定价】-是，变动单价字段不可编辑，【是否定价】-否，变动单价字段可编辑；其余字段都不可编辑
        this.isShowDownBtn = true;
        this.isDisableOverdueInterest = true;
        return [];
      } else if (currentContractStatus == 'ZT025') {
        // 删除审批中
        this.isShowDownBtn = true;
        this.isDisableOverdueInterest = true;
        return [];
      } else if (currentContractStatus == 'ZT024') {
        // 生效审批中
        this.isShowDownBtn = true;
        this.isDisableOverdueInterest = true;
        return [];
      } else if (currentContractStatus == 'ZT022') {
        // 撤回审批中
        this.isDisableOverdueInterest = true;
        this.isShowDownBtn = true;
        return [];
      } else if (currentContractStatus == 'ZT023') {
        // 关闭审批中
        this.isShowDownBtn = true;
        this.isDisableOverdueInterest = true;
        return [];
      } else if (currentContractStatus == 'ZT061') {
        // 修订中禁用这些
        this.isDisabledGenerateSales = true;
        let disabledList = [
          'isFixedPrice',
          'isLongRange',
          'pricingRule',
          'overShippedPercentage',
          'shortShippedPercentage',
          'performanceBondPayMethodCode',
          'performanceBond',
          'warrantyClause',
          'recyclingCompanyName',
          'platformCompanyName',
          'isGenerateSales',
          'mark',
        ];
        return disabledList;
      } else if (currentContractStatus == 'ZT051') {
        let disabledList = [
          'isFixedPrice',
          'isLongRange',
          'pricingRule',
          'overShippedPercentage',
          'shortShippedPercentage',
          'performanceBondPayMethodCode',
          'performanceBond',
          'warrantyClause',
          'recyclingCompanyName',
          'platformCompanyName',
          'mark',
        ];
        // 修改已驳回
        return disabledList;
      } else {
        return;
      }
    },
  },
};
